<div class="wrapper">
    <button
        [ngClass]="{ 'see-all-standards': !allExpanded, 'see-fewer-standards': allExpanded }"
        (click)="updateButtonLabel()"
    >
        <app-icon [type]="!allExpanded ? 'Plus' : 'Minus'"></app-icon>
        {{ !allExpanded ? firstText : secondText }}
    </button>
</div>
